
import React, { useState, useEffect, useContext } from "react";

import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { contentContext } from "../../context/contentContext";


const Sidebar = () => {
    let { id } = useParams();
    const location = useLocation();

    const [manage, setManage] = useState(false);
    const [report, setReport] = useState(false);
    const [settings, setSettings] = useState(false);
    const [auction, setAuction] = useState(false);
    const isActive = (path) => location.pathname === path ? 'active' : '';
    // const [activeMenuObj, setActiveMenuObj] = useState({});
    const navigate = useNavigate();


    const { isLoading, setIsLoading, setActiveTab, flagg, setData, setBidsAdvSearch, setSaveLeadId, setlookUpType, setBidsSearch, setLookupSearch, setClientNameSearch, setFlagg, setActivePageName, setUserSearch, setCompanyAdvSearch, setCompanySearch, setClientMangeSearch, setDealSearch, setClientAdvSearch, setDealsAdvSearch, userData, setContent, setSearchPayload, setCategorySearch, setContentSearch, leadSearch, setFilterLeads, setLeadSearch, setActiveSearch, setUserData, activeMenuObj, setActiveMenuObj, activeMenuId, GetTimeActivity, toggleMenu, setToggleMenu, setActiveMenuId, setSortingPayload, setItemSearch } = useContext(contentContext)



    const handleMenu = (e, item) => {
        if (!isLoading && activeMenuId !== item.menuid) {
            setActiveTab("details")
            // console.log('handleMenu-------------->',item.menuid)

            setActiveMenuId(item.menuid)
            let id = item.menu.split(" ").join("").toLowerCase()
            GetTimeActivity()
            setFlagg("")
            setLeadSearch("")
            setActiveSearch("")
            setFilterLeads("")
            setContentSearch("")
            setCategorySearch("")
            setSearchPayload({})
            setClientAdvSearch({})
            setBidsSearch("")
            setItemSearch("");
            setDealSearch("")
            setSortingPayload("")
            setlookUpType("")
            setClientNameSearch("")
            setSaveLeadId("")
            setDealsAdvSearch({})
            setData([])
            setLookupSearch("")
            setClientMangeSearch("")
            setBidsAdvSearch({})
            setCompanyAdvSearch({})
            setCompanySearch("")
            setUserSearch("")
            setActivePageName("")
            setContent([])
            if (id === "servicesconfig") {
                navigate("/settings/serviceconfig");
            } else if (id === "appconfig") {
                navigate("/settings/" + id);
            }
            else {
                navigate("/" + id);
            }

        }
    }
    function sortPermissions(permissions) {
        return permissions.sort((a, b) => a.menuid - b.menuid);
    }


    const handleActiveMenuObj = (e, name) => {
        GetTimeActivity()
        setActiveTab("details")
        setFlagg("")
        setLeadSearch("")
        setActiveSearch("")
        setFilterLeads("")
        setCategorySearch("")
        setDealsAdvSearch({})
        setContent([])
        setDealSearch("")
        setClientMangeSearch("")

        setBidsAdvSearch({})
        setClientNameSearch("")
        setLookupSearch("")
        setClientAdvSearch({})
        setCompanySearch("")
        setSearchPayload({})
        setlookUpType("")
        setCompanyAdvSearch({})
        setActivePageName("")
        setUserSearch("")
        // console.log('handleActiveMenuObj------------>',name)
        setActiveMenuObj({ ...activeMenuObj, [name]: !activeMenuObj[name] })

    }
    const handleMenuClick = (path) => {
        navigate(path);

    };
    // console.log("usertypeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",userData)
    return (
        <>

            <div className={`vertical-menu ${toggleMenu ? 'menu-show' : 'menu-hide'}`}             >

                <div data-simplebar className="h-100">

                    <div id="sidebar-menu">
                        <ul className="metismenu list-unstyled" id="side-menu">

                            {userData && userData.permissions && userData.permissions.length > 0
                                ? sortPermissions(userData.permissions).map((eachItem) => {
                                    let isDisplay = eachItem.display;
                                    let isEnable = eachItem.enable;
                                    return (
                                        <>
                                            {isDisplay === true && (
                                                <li
                                                    id={`sidemenu-${eachItem.menuid}`}
                                                    key={eachItem.menuid}
                                                    className={`${eachItem.menuid === activeMenuId ? 'active' : ''} ${isLoading ? 'pe-none' : ''}`}
                                                    onClick={(e) =>
                                                        eachItem.submenus === undefined
                                                            ? handleMenu(e, eachItem)
                                                            : handleActiveMenuObj(e, eachItem.menu)
                                                    }
                                                >
                                                    <a
                                                        className={`${eachItem.submenus ? 'has-arrow' : ''} waves-effect`}
                                                        id={`sidemenu-${eachItem.menuid}-link`}
                                                    >
                                                        <i className="material-symbols-outlined" id={`sidemenu-${eachItem.menuid}-icon`}>
                                                            {eachItem.icon}
                                                        </i>
                                                        <span key="t-dashboards" id={`sidemenu-${eachItem.menuid}-text`}>
                                                            {eachItem.menu}
                                                        </span>
                                                    </a>
                                                    {eachItem.submenus && eachItem.submenus.length > 0 && (
                                                        <ul
                                                            className={
                                                                activeMenuObj[eachItem.menu]
                                                                    ? 'sub-menu mm-show active'
                                                                    : 'sub-menu mm-collapse'
                                                            }
                                                            aria-expanded="false"
                                                            id={`sidemenu-${eachItem.menuid}-submenus`}
                                                        >
                                                            {eachItem.submenus.map((eachSubmenu) => (
                                                                <li
                                                                    id={`sidemenu-${eachSubmenu.menuid}`}
                                                                    key={eachSubmenu.menuid}
                                                                    className={`${eachSubmenu.menuid === activeMenuId ? 'active' : ''} ${isLoading ? 'pe-none' : ''
                                                                        }`}
                                                                    onClick={(e) => handleMenu(e, eachSubmenu)}
                                                                >
                                                                    <a id={`sidemenu-${eachSubmenu.menuid}-link`}>{eachSubmenu.menu}</a>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            )}
                                        </>
                                    );
                                })
                                : null}
                        </ul>
                    </div>


                    <p className="activity_time">Action: {localStorage.getItem("timeActivity")}</p>

                </div>
            </div>

        </>
    );
};

export default Sidebar;
